import { useQuery } from '@tanstack/react-query'
import { useMedplum } from '@medplum/react'
import { FAX_TASK_TYPE } from './useFaxInbox'

export function useUnreadInboxFaxes() {
  const medplum = useMedplum()

  return useQuery({
    queryKey: ['fax-inbox-unread'],
    queryFn: async () => {
      const bundle = await medplum.search(
        'Task',
        new URLSearchParams({
          code: FAX_TASK_TYPE,
          status: 'requested',
          _count: '1',
        }),
      )
      return (bundle.entry?.length ?? 0) > 0
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
  })
}
